import * as React from 'react';

import { cn } from '../../utils/cn';

const Textarea = React.forwardRef(({ className, error, ...props }, ref) => {
    return (
        <textarea
            className={cn(
                'flex min-h-[60px] w-full rounded-md border bg-[var(--background)] px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
                error
                    ? 'border-destructive focus-visible:border-destructive focus-visible:ring-[var(--ring-destructive)]'
                    : 'border-input focus-visible:border-ring focus-visible:ring-ring',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Textarea.displayName = 'Textarea';

export { Textarea };
